import {
  ContentType,
  TrackOrderUiState,
} from "@redotech/redo-support-conversation-protocol-common/conversation-protocol";
import * as z from "zod";
import { array, literal, number, object, string } from "zod";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
} from "../message-parser-utils";
// TRACK ORDER
export const TrackOrderCustomerInputContentSchema = object({
  email: string(),
  orderId: string(),
});

export type TrackOrderCustomerInputContent = z.infer<
  typeof TrackOrderCustomerInputContentSchema
>;

export const TimelineEventSchema = object({
  status: string(),
  datetime: string().optional(),
  label: string(),
  isCompleted: z.boolean(),
  color: z.string().optional(),
});
export type TimelineEventType = z.infer<typeof TimelineEventSchema>;

export const TrackableFulfillmentSchema = array(
  object({
    orderCreatedAt: string().optional(),
    estimatedDeliveryDate: string().nullish(),
    trackingDetails: array(TimelineEventSchema).optional(),
    trackingUrl: string().nullish(),
    redoTrackingPageLink: string().optional(),
    carrier: string().nullish(),
    trackingNumber: string().nullish(),
    lineItems: array(
      object({
        productId: string(),
        productTitle: string(),
        variantId: string().nullish(),
        variantTitle: string().nullish(),
        url: string().nullish(),
        price: object({ amount: number(), currencyCode: string() }),
        priceRange: object({
          minVariantPrice: object({ amount: number(), currencyCode: string() }),
          maxVariantPrice: object({ amount: number(), currencyCode: string() }),
        }).optional(),
        imageUrl: string().nullish(),
        handle: z.preprocess(
          (val) => (typeof val === "object" && val !== null ? null : val),
          string().nullish(),
        ),
      }),
    ),
  }),
);

export type TrackableFulfillmentType = z.infer<
  typeof TrackableFulfillmentSchema
>;

export const TrackOrderUiStructuredMessageSchema = z.discriminatedUnion(
  "state",
  [
    object({ state: literal(TrackOrderUiState.ORDER_LOOKUP) }),
    object({
      state: literal(TrackOrderUiState.FOUND_ORDER),
      orderId: z.string(),
      email: z.string(),
      trackableFulfillmentsToDisplay: TrackableFulfillmentSchema,
    }),
  ],
);

export const TrackOrderUiMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.TRACK_ORDER_UI),
  structuredContent: TrackOrderUiStructuredMessageSchema.optional(),
  customerInputContent: TrackOrderCustomerInputContentSchema.optional(),
});

export const TrackOrderUiMessageDbParser = TrackOrderUiMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type TrackOrderUiMessageType = z.infer<
  typeof TrackOrderUiMessageDbParser
>;
